import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./TwitterTrendDeepDive.scss";
import isEqual from "react-fast-compare";
import TwitterTrendKpi from "./TwitterTrendKpi";
import { Tabs } from "antd";
import TabPane from "antd/lib/tabs/TabPane";
import GoogleTrendsContainerForTwitter from "./GoogleTrendsContainerForTwitter";
import InterestOverTime from "./InterestOverTime";
import OverlayGoogleTrend from "./OverlayGoogleTrend";
import TwitterTrendTagCloud from "./TwitterTrendTagCloud";

const TwitterTrendDeepDive = ({}) => {
  const dispatch = useDispatch();
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  // const trendsKpiData = useSelector(
  //   (state) => state?.Screens?.screen?.deep_dive?.twitter_trend
  // );
  // console.log("trendsKpiData : ", trendsKpiData);
  const handleTabs = (e) => {
    setCurrentActiveTab(e);
    // if (e === 2 && !mention?.news_mentions?.status === "successful") {
    //   dispatch(setMentionTabsNews(true));
    // }
  };
  return (
    <>
      <div className="TwitterTrendDeepDive w-100 h-100">
        <div className="TwitterTrendDeepDive__kpi">
          <TwitterTrendKpi />
        </div>
        <div className="TwitterTrendDeepDive__trendline mb-sm-3">
          <div className="TwitterTrendDeepDive__trendline--overtime">
            <InterestOverTime />
          </div>
        </div>
        <div className="TwitterTrendDeepDive__trendreport">
          <Tabs
            defaultActiveKey="1"
            className="workSpace__tabs deevdive_details bg__white border border-color border-radius-4"
            onChange={(e) => handleTabs(e)}
            destroyInactiveTabPane={false}
          >
            <TabPane
              tab={
                <div className="d-flex align-items-center spin-d-flex">
                  <span className="mr-1">Twitter Trend Report</span>
                </div>
              }
              className="h-100 text-gray"
              key="1"
            >
              <TwitterTrendTagCloud currentActiveTab={currentActiveTab} />
            </TabPane>
            <TabPane
              tab={
                <div className="d-flex align-items-center spin-d-flex">
                  <span className="mr-1">Google Trend Report</span>
                </div>
              }
              className="text-gray"
              key="2"
            >
              <GoogleTrendsContainerForTwitter />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
};
export default React.memo(TwitterTrendDeepDive, isEqual);
